import rootStore from './rootStore';
import { reaction } from "mobx"
import { stores, history } from '../history_mobx';

const myStore=new rootStore(stores.router,history);
export default myStore;